import { jsx, jsxs } from 'react/jsx-runtime';
import styles from '../Footer.module.scss.js';
import SvgArrowUp from '../assets/arrow-up.svg.js';
import Image from '../../Image/Image.js';

const Partners = ({ partnerLinks }) => {
  return /* @__PURE__ */ jsx("div", { className: styles.partnerWrapper, children: /* @__PURE__ */ jsxs("div", { className: styles.partnerLogos, "data-test-id": "footer-partners", children: [
    /* @__PURE__ */ jsx("div", { className: styles.logosContainer, children: partnerLinks.map((link) => {
      const {
        imageUrl,
        text = "",
        url,
        width = 23,
        height = 23
      } = link ?? {};
      const renderWithoutURL = /* @__PURE__ */ jsx("div", { className: styles.partnerImgWrapper, children: imageUrl ? /* @__PURE__ */ jsx(
        Image,
        {
          src: imageUrl,
          alt: text ?? "",
          className: styles.partnerImg,
          width,
          height,
          "data-test-id": `footer-${text}-image`,
          "aria-label": text,
          loading: "lazy"
        }
      ) : /* @__PURE__ */ jsx("div", { children: text }) });
      const renderWithURL = url && /* @__PURE__ */ jsx(
        "a",
        {
          href: url,
          target: "_blank",
          rel: "noopener noreferrer",
          "data-test-id": `footer-${text}-link`,
          "aria-label": `Go to ${text}`,
          children: renderWithoutURL
        }
      );
      return /* @__PURE__ */ jsx(
        "div",
        {
          "data-test-id": `footer-partner`,
          className: styles.logo,
          children: url ? renderWithURL : renderWithoutURL
        },
        `${text}-${url}`
      );
    }) }),
    /* @__PURE__ */ jsxs("a", { className: styles.backToTopLink, href: "#", "data-test-id": "back-to-top", children: [
      /* @__PURE__ */ jsx("span", { className: styles.backToTopText, children: "Back to top" }),
      /* @__PURE__ */ jsx(SvgArrowUp, { className: styles.backToTopArrow })
    ] })
  ] }) });
};

export { Partners as default };
//# sourceMappingURL=Partners.js.map
